let lenis;

document.addEventListener('DOMContentLoaded', function () {

	gsap.registerPlugin(ScrollTrigger);
	//ScrollTrigger.config({ ignoreMobileResize: true });
	// ScrollTrigger.normalizeScroll(true); // enable

	// ==================

	document.querySelectorAll('.mprojects').forEach(item => {
		gsap.to(item, {
			scrollTrigger: {
				trigger: item,
				start: 'center+=100 bottom',
				end: 'center top',
				invalidateOnRefresh: true,
				onEnter() {
					item.classList.add('m-active');
				},
				// onLeave() {

				// },
				// onEnterBack() {

				// },
				// onLeaveBack() {

				// },
			}
		});
	});


	document.querySelectorAll('.week__title').forEach(item => {
		let initX = 20;
		if (window.matchMedia(`(min-width: ${media_md}px)`).matches) {
			initX = -20;
		}

		gsap.set(item, {
			x: `${initX}%`,
		});
		gsap.to(item, {
			x: `${initX - 50}%`,
			ease: 'none',
			scrollTrigger: {
				trigger: item,
				start: 'top-=100 bottom',
				end: 'bottom+=100 top',
				scrub: 0,
				invalidateOnRefresh: true,
				// markers: true,
			}
		});
	});

	document.querySelectorAll('.js_swiper_week').forEach(slider => {

		let shiftAmount = '-50vw';
		if (window.matchMedia(`(max-width: ${media_md - 0.2}px)`).matches) {
			shiftAmount: '-100vw';
		}

		let initX = '0vw';
		let finalX = shiftAmount;
		if (slider.classList.contains('m-right')) {
			initX = shiftAmount;
			finalX = '0vw';
		}

		gsap.set(slider, {
			x: initX,
		});
		gsap.to(slider, {
			x: finalX,
			ease: 'none',
			scrollTrigger: {
				trigger: slider,
				start: 'top-=100 bottom',
				end: 'bottom+=100 top',
				scrub: 0,
				invalidateOnRefresh: true,
				// markers: true,
			}
		});
	});
	// ============


	lenis = new Lenis()

	// lenis.on('scroll', (e) => {
	// 	console.log(e)
	// })

	lenis.on('scroll', ScrollTrigger.update)

	gsap.ticker.add((time) => {
		lenis.raf(time * 1000)
	})

	gsap.ticker.lagSmoothing(0)

	// 

	document.querySelectorAll('.js_scrollto').forEach(item => {
		item.addEventListener('click', (e) => {
			const target = item.getAttribute('href');
			lenis.scrollTo(target);
		});
	});




});